// extracted by mini-css-extract-plugin
module.exports = {"desktopContainer":"ElementMobileNotSupported_desktopContainer__1ueoV","mobileContainer":"ElementMobileNotSupported_mobileContainer__1DxMR"};